/** Generated js for domain-specific scripting
 * by common\modules\domains\helpers\DomainJavascriptWriter
 */

(function () {
    'use strict';

    /* ── 1. Video: juiste bron kiezen + betrouwbaar autoplay ───────────── */
    var video = document.querySelector('.hero-video');
    if (video) {
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        var src = isMobile
            ? video.getAttribute('data-src-mobile')
            : video.getAttribute('data-src-desktop');

        if (src) {
            var source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            video.appendChild(source);
            video.load();

            // autoplay forceren (sommige browsers negeren het attribuut)
            var playPromise = video.play();
            if (playPromise !== undefined) {
                playPromise.catch(function () {
                    // autoplay geblokkeerd -> poster blijft staan, geen fout tonen
                });
            }
        }
    }

    /* ── 2. Fase-card wegklikken ───────────────────────────────────────── */
    var card = document.querySelector('.hero-fase-card');
    var closeBtn = document.querySelector('.hero-fase-close');
    if (card && closeBtn) {
        closeBtn.addEventListener('click', function () {
            card.style.display = 'none';
        });
    }
})();


/* Interactie: muis slepen, wheel naar horizontaal, pijltjes, klikbescherming, keyboard */
/* Interactie: muis slepen, wheel naar horizontaal, pijltjes, klikbescherming, keyboard */
(() => {
  const outer = document.getElementById('newsScroller');
  const viewport = document.getElementById('newsViewport');
  if (!outer || !viewport) return;
  const track = viewport.querySelector('.news-track');
  const prev = outer.querySelector('.news-nav.prev');
  const next = outer.querySelector('.news-nav.next');
  
  /* Stapgrootte is kaartbreedte plus gap */
  const stepSize = () => {
    const card = track.querySelector('.news-card');
    if (!card) return viewport.clientWidth * 0.9;
    const gap = parseFloat(getComputedStyle(track).gap || 16);
    return card.getBoundingClientRect().width + gap;
  };
  
  /* Pijlen klikken */
  const by = dir => viewport.scrollBy({ left: dir * stepSize(), behavior: 'smooth' });
  prev?.addEventListener('click', () => by(-1));
  next?.addEventListener('click', () => by(1));
  
  /* Keyboard op de focusbare viewport */
  viewport.addEventListener('keydown', e => {
    if (e.key === 'ArrowRight'){ e.preventDefault(); by(1); }
    if (e.key === 'ArrowLeft'){ e.preventDefault(); by(-1); }
  });
  
  /* Wheel naar horizontaal voor touchpads en muiswiel */
  const wheelToX = e => {
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)){
      e.preventDefault();
      viewport.scrollLeft += e.deltaY;
    }
  };
  viewport.addEventListener('wheel', wheelToX, { passive:false });
  track.addEventListener('wheel', wheelToX, { passive:false });
  
  /* Desktop drag met pointer events. Touch gebruikt native scroll. */
  let down = false, startX = 0, startLeft = 0, moved = false;
  const isMouse = e => e.pointerType === 'mouse' || e.pointerType === undefined;
  
  viewport.addEventListener('pointerdown', e => {
    // Niet intercepten als op een link of button wordt geklikt
    if (e.target.closest('a, button, .btn-primary')) return;
    if (!isMouse(e)) return;
    
    down = true; 
    moved = false;
    startX = e.clientX;
    startLeft = viewport.scrollLeft;
    viewport.classList.add('is-dragging');
    viewport.setPointerCapture?.(e.pointerId);
  });
  
  viewport.addEventListener('pointermove', e => {
    if (!down) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 5) moved = true; // verhoogde drempel
    viewport.scrollLeft = startLeft - dx;
  });
  
  const endDrag = e => {
    if (!down) return;
    down = false;
    viewport.classList.remove('is-dragging');
    viewport.releasePointerCapture?.(e.pointerId);
  };
  
  viewport.addEventListener('pointerup', endDrag);
  viewport.addEventListener('pointerleave', endDrag);
  
  /* Klikbescherming zodat een drag geen link activeert */
  viewport.addEventListener('click', e => {
    if (moved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  
  /* Pijlstatus bijwerken en clipping voorkomen aan het eind */
  const updateArrows = () => {
    const max = viewport.scrollWidth - viewport.clientWidth - 1;
    if (prev) prev.disabled = viewport.scrollLeft <= 0;
    if (next) next.disabled = viewport.scrollLeft >= max;
  };
  
  viewport.addEventListener('scroll', updateArrows, { passive:true });
  window.addEventListener('resize', updateArrows);
  updateArrows();
})();


/* expander */
if (document.querySelector('#beforeafterslider')) {
  new BeforeAfter({ id: '#beforeafterslider' });
}

document.addEventListener('click', function (event) {
  const isExpandButton =
    event.target.matches('.expand-button') ||
    event.target.closest('.expand-button') !== null;

  const expanderParent = event.target.closest('.expander');

  if (isExpandButton && expanderParent) {
    event.preventDefault();
    toggleExpander(expanderParent, true);
  }
});

function toggleExpander(expanderElement, toggle) {
  if (toggle) {
    expanderElement.classList.toggle('expand');
  }
  let maxHeight = '999em';
  if (!expanderElement.classList.contains('expand')) {
    maxHeight = expanderElement.dataset.minimalHeight ?? '50px';
  }
  const contentElement = expanderElement.querySelector('.expander-content');
  if (contentElement) {
    contentElement.style.maxHeight = maxHeight;
  }
}

document.querySelectorAll('.expander').forEach(expander => {
  toggleExpander(expander, false);
});



    /* kavelkiezer */
    (function (global) { "use strict";
        const ready = (fn) => { if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn, { once: true }); else fn(); };

        ready(() => {
            const wrapper = document.querySelector(".map-wrapper");
            
            // Vroege exit als de map-wrapper niet bestaat
            if (!wrapper) return;
            
            const svg = document.getElementById("kavelSvg");
            const bgImg = document.getElementById("mapCanvas");
            const tooltip = document.getElementById("kavel-tooltip");
            const panel = document.getElementById("details");
            const overlay = document.getElementById("map-overlay");
            const legend = document.getElementById("legend");
            const zoomControls = wrapper.querySelector(".zoom-controls");
            const viewSelect = document.getElementById("viewSelect");
            const viewSelectWrap = document.querySelector(".view-select");
            const fsBtn = document.getElementById("toggle-fullscreen");
    
            // Extra checks voor kritieke elementen
            if (!svg || !bgImg || !panel || !legend) return;

            // Focus management (VP2)
            let previouslyFocusedEl = null;
            let focusTrapEnabled = false;
            let focusTrapHandler = null;

            const els = {
                title: document.getElementById("details-title"),
                status: document.getElementById("details-status"),
                naam: document.getElementById("details-naam"),
                prijs: document.getElementById("details-prijs"),
                opp: document.getElementById("details-oppervlakte"),
                brochure: document.getElementById("cta-brochure"),
                paspoort: document.getElementById("cta-paspoort"),
                info: document.getElementById("cta-info"),
                carInner: document.getElementById("details-carousel-inner"),
                carInd: document.getElementById("details-carousel-indicators"),
                carouselEl: document.getElementById("details-carousel"),
            };

            // Fallbackafbeelding als data-URL (VP4)
            const FALLBACK_IMG = 'data:image/svg+xml;utf8,' +
                encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 480">
  <defs><style>.t{font:600 24px system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial}</style></defs>
  <rect width="800" height="480" fill="#e9ecef"/>
  <g fill="#adb5bd">
    <circle cx="120" cy="120" r="48"/>
    <rect x="200" y="96" width="420" height="48" rx="8"/>
    <rect x="200" y="160" width="360" height="32" rx="8"/>
    <rect x="64" y="248" width="672" height="192" rx="12"/>
  </g>
  <text x="50%" y="60%" text-anchor="middle" fill="#6c757d" class="t">Afbeelding niet beschikbaar</text>
</svg>`);

            // Skeleton + fallback koppelen (VP4)
            function enhanceImageLoading(img, holder) {
                holder?.classList.add('is-loading');
                function clearSkeleton(){ holder?.classList.remove('is-loading'); }
                img.addEventListener('load', clearSkeleton, { once: true });
                if (img.complete && img.naturalWidth > 0) clearSkeleton();
                img.addEventListener('error', () => {
                    if (img.dataset.fallbackApplied) return;
                    img.dataset.fallbackApplied = '1';
                    img.src = FALLBACK_IMG;
                    img.alt = (img.alt || 'Afbeelding') + ' niet geladen';
                    clearSkeleton();
                }, { once: true });
            }

            function isUI(target) {
                return !!(target.closest('.fs-ui')
                    || target.closest('.zoom-controls')
                    || target.closest('.view-select')
                    || target.closest('#legend')
                    || target.closest('.filter-chip')
                    || target.closest('select, button, a, input, textarea, label'));
            }

            /* Helpers: tonen/verbergen per veld */
            function setTextOrHide(el, text) {
                if (!el) return;
                if (text && String(text).trim() !== "") {
                    el.textContent = text;
                    el.style.display = "";
                } else {
                    el.textContent = "";
                    el.style.display = "none";
                }
            }
            function setLinkOrHide(a, href) {
                if (!a) return;
                if (href && String(href).trim() !== "" && href !== "#") {
                    a.href = href;
                    a.style.display = "inline-block";
                    a.classList.remove("disabled");
                    a.removeAttribute("aria-disabled");
                } else {
                    a.removeAttribute("href");
                    a.style.display = "none";
                    a.classList.add("disabled");
                    a.setAttribute("aria-disabled", "true");
                }
            }

            // A11y voor kavels (VP1)
            function applyA11yToAreas() {
                const areas = svg.querySelectorAll(".hover-area");
                areas.forEach(path => {
                    const naam = path.getAttribute("data-naam") || "Kavel";
                    const status = path.getAttribute("data-status") || "";
                    const prijs = path.getAttribute("data-prijs") || "";
                    const opp = path.getAttribute("data-oppervlakte") || "";
                    const parts = [naam, status, prijs, opp].filter(Boolean);
                    path.setAttribute("role", "button");
                    if (!path.hasAttribute("tabindex")) path.setAttribute("tabindex", "0");
                    path.setAttribute("aria-label", parts.join(", "));
                });
            }

            // Update aria-labels van filterchips (VP3)
            function updateLegendAria(counts, active) {
                const map = { available:"Beschikbaar", option:"Onder optie", sold:"Verkocht", future:"Nog niet in verkoop", all:"Alles" };
                const btns = legend.querySelectorAll("[data-filter]");
                btns.forEach(btn => {
                    const key = btn.getAttribute("data-filter");
                    const label = map[key] || key;
                    const n = key === "all"
                        ? counts.available + counts.option + counts.sold + counts.future
                        : (counts[key] || 0);
                    const isActive = active ? key === active : key === "all";
                    btn.setAttribute("aria-label", `${label}, ${n} kavels${isActive ? ", actief" : ""}`);
                    btn.setAttribute("aria-pressed", isActive ? "true" : "false");
                });
            }

            function getFocusable(container) {
                return Array.from(container.querySelectorAll(
                    'a[href]:not([disabled]), button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
                )).filter(el => el.offsetParent !== null || el === document.activeElement);
            }
            function activateFocusTrap() {
                if (focusTrapEnabled) return;
                focusTrapEnabled = true;
                const focusables = getFocusable(panel);
                const first = focusables[0] || panel;
                const last = focusables[focusables.length - 1] || panel;

                focusTrapHandler = function (e) {
                    if (!focusTrapEnabled) return;
                    if (e.key !== "Tab") return;
                    const current = document.activeElement;
                    if (e.shiftKey) {
                        if (current === first || current === panel) { e.preventDefault(); last.focus(); }
                    } else {
                        if (current === last) { e.preventDefault(); first.focus(); }
                    }
                };
                document.addEventListener("keydown", focusTrapHandler);
                (panel.querySelector("[data-action='close']") || first).focus();
            }
            function deactivateFocusTrap() {
                focusTrapEnabled = false;
                if (focusTrapHandler) { document.removeEventListener("keydown", focusTrapHandler); focusTrapHandler = null; }
            }

            // Views uit templates
            const templates = Array.from(document.querySelectorAll("div.map-view"));
            const views = templates.map(t => ({
                id: t.dataset.id,
                label: t.dataset.label || t.dataset.id,
                background: t.dataset.background || "",
                viewBox: t.dataset.vb || "0 0 1920 1080",
                tpl: t
            }));

            // Dropdown tonen indien >1
            if (views.length <= 1) {
                if (viewSelectWrap) viewSelectWrap.style.display = "none";
            } else {
                viewSelect.innerHTML = views.map(v => `<option value="${v.id}">${v.label}</option>`).join("");
                if (viewSelectWrap) viewSelectWrap.style.display = "";
            }

            // Preload backgrounds
            views.forEach(v => { const im = new Image(); im.src = v.background; });

            // State
            let currentView = null;
            const viewState = {};
            let scale = 1, panX = 0, panY = 0;
            const MIN_SCALE = 1, MAX_SCALE = 6;

            let suppressClickUntil = 0;
            let isOpen = false, pinnedId = null, pinnedNumericId = null;

            const activePointers = new Map();
            let isPinching = false;
            const pinch = { startDist: 0, startScale: 1, lastCX: 0, lastCY: 0 };

            // Filters
            let activeFilter = null;

            function statusBadgeColor(status) {
                const s = (status || "").toLowerCase();
                if (s.includes("beschikbaar")) return "bg-available";
                if (s.includes("optie")) return "bg-option";
                if (s.includes("verkocht")) return "bg-sold";
                if (s.includes("nog niet")) return "bg-future";
                return "bg-secondary";
            }

            function buildTooltipHTMLFromPath(path, mini) {
                const naam   = path.getAttribute("data-naam") || "";
                const bouwnummer  = path.getAttribute("data-bouwnummer") || "";
                const prijs  = path.getAttribute("data-prijs") || "";
                const status = path.getAttribute("data-status") || "";
                const imgUrl = path.getAttribute("data-afbeelding") || "";

                const badgeClass = statusBadgeColor(status);
                const imgTag = mini ? "" : (imgUrl ? `<img class="thumb" src="${imgUrl}" alt="">` : "");

                const bits = [];
                if (status) bits.push(`<span class="badge rounded-pill ${badgeClass}">${status}</span>`);
                if (naam)   bits.push(`<div class="fw-semibold mt-1">${naam}</div>`);
                if (bouwnummer)   bits.push(`<div class="mt-1">${bouwnummer}</div>`);
                if (prijs)  bits.push(`<div class="price">${prijs}</div>`);

                return `${imgTag}<div>${bits.join("")}</div>`;
            }
            function moveTooltip(clientX, clientY) {
                const rect = wrapper.getBoundingClientRect();
                tooltip.style.display = "block";
                const tw = tooltip.offsetWidth, th = tooltip.offsetHeight;
                const x = Math.max(8, Math.min(clientX - rect.left + 14, rect.width - tw - 8));
                const y = Math.max(8, Math.min(clientY - rect.top + 14, rect.height - th - 8));
                tooltip.style.left = x + "px"; tooltip.style.top = y + "px";
            }
            const hideTooltip = () => { tooltip.style.display = "none"; tooltip.classList.remove("is-mini"); };

            function applyTransform() {
                const t = `matrix(${scale},0,0,${scale},${panX},${panY})`;
                bgImg.style.transform = t;
                svg.style.transform = t;
            }
            function constrainPan() {
                const vw = wrapper.clientWidth, vh = wrapper.clientHeight;
                const cw = vw * scale, ch = vh * scale;
                const minX = Math.min(0, vw - cw);
                const minY = Math.min(0, vh - ch);
                panX = Math.max(minX, Math.min(panX, 0));
                panY = Math.max(minY, Math.min(panY, 0));
            }
            const updateDraggableClass = () => { if (!isOpen && scale > 1) wrapper.classList.add("draggable"); else wrapper.classList.remove("draggable"); };

            // Carousel helpers (VP4)
            function clearCarousel() {
                els.carInner.innerHTML = "";
                els.carInd.innerHTML = "";
                try {
                    const inst = global.bootstrap?.Carousel.getInstance(els.carouselEl);
                    if (inst) inst.dispose();
                } catch(e){}
                els.carouselEl.style.display = "none";
                els.carouselEl.querySelector(".carousel-control-prev")?.classList.add("visually-hidden");
                els.carouselEl.querySelector(".carousel-control-next")?.classList.add("visually-hidden");
                els.carouselEl.querySelector(".carousel-indicators")?.classList.add("visually-hidden");
            }
            function renderSingleImage(url, altBase) {
                clearCarousel();
                els.carouselEl.style.display = "";

                const item = document.createElement("div");
                item.className = "carousel-item active";

                const holder = document.createElement("div");
                holder.className = "img-holder is-loading";

                const img = document.createElement("img");
                img.alt = altBase || "Kavel";
                img.loading = "lazy";
                img.decoding = "async";
                img.referrerPolicy = "no-referrer";
                img.src = url && String(url).trim() ? url : FALLBACK_IMG;

                holder.appendChild(img);
                item.appendChild(holder);
                els.carInner.appendChild(item);

                enhanceImageLoading(img, holder);

                els.carouselEl.querySelector(".carousel-control-prev")?.classList.add("visually-hidden");
                els.carouselEl.querySelector(".carousel-control-next")?.classList.add("visually-hidden");
                els.carouselEl.querySelector(".carousel-indicators")?.classList.add("visually-hidden");
            }
            function renderCarousel(urls, altBase) {
                clearCarousel();
                if (!urls || !urls.length) return;
                els.carouselEl.style.display = "";

                urls.forEach((url, idx) => {
                    const item = document.createElement("div");
                    item.className = "carousel-item" + (idx === 0 ? " active" : "");

                    const holder = document.createElement("div");
                    holder.className = "img-holder is-loading";

                    const img = document.createElement("img");
                    img.alt = `${altBase || "Kavel"} ${idx + 1}`;
                    img.loading = "lazy";
                    img.decoding = "async";
                    img.referrerPolicy = "no-referrer";
                    img.dataset.src = url && String(url).trim() ? url : FALLBACK_IMG;

                    if (idx === 0) { img.src = img.dataset.src; delete img.dataset.src; }

                    holder.appendChild(img);
                    item.appendChild(holder);
                    els.carInner.appendChild(item);

                    enhanceImageLoading(img, holder);

                    const dot = document.createElement("button");
                    dot.type = "button";
                    dot.setAttribute("data-bs-target", "#details-carousel");
                    dot.setAttribute("data-bs-slide-to", String(idx));
                    if (idx === 0) dot.className = "active";
                    dot.ariaLabel = "Slide " + (idx + 1);
                    els.carInd.appendChild(dot);
                });

                els.carouselEl.querySelector(".carousel-control-prev")?.classList.remove("visually-hidden");
                els.carouselEl.querySelector(".carousel-control-next")?.classList.remove("visually-hidden");
                els.carouselEl.querySelector(".carousel-indicators")?.classList.remove("visually-hidden");

                if (global.bootstrap && global.bootstrap.Carousel) {
                    new global.bootstrap.Carousel(els.carouselEl, { interval: 5000, ride: false, pause: "hover", touch: true, wrap: true });
                    els.carouselEl.addEventListener("slide.bs.carousel", (e) => {
                        const img = e.relatedTarget?.querySelector("img");
                        const holder = e.relatedTarget?.querySelector(".img-holder");
                        if (img && img.dataset?.src) {
                            holder?.classList.add("is-loading");
                            img.src = img.dataset.src;
                            delete img.dataset.src;
                        }
                    });
                }
            }

            function fillPanelFromPath(path) {
                const naam   = path.getAttribute("data-naam") || "";
                const prijs  = path.getAttribute("data-prijs") || "";
                const status = path.getAttribute("data-status") || "";
                const imgUrl = path.getAttribute("data-afbeelding") || "";
                const fotos  = JSON.parse(path.getAttribute("data-fotos") || "[]");
                const brochure = path.getAttribute("data-brochure") || "";
                const paspoort = path.getAttribute("data-paspoort") || "";
                const info = path.getAttribute("data-info") || "";

                // Basisinfo bovenaan
                setTextOrHide(els.title, naam ? `${naam} details` : "Kavel details");
                setTextOrHide(els.naam, naam);
                if (status) {
                    els.status.textContent = status;
                    els.status.className = "badge rounded-pill " + statusBadgeColor(status);
                    els.status.style.display = "";
                } else {
                    els.status.textContent = "";
                    els.status.className = "badge rounded-pill";
                    els.status.style.display = "none";
                }
                setTextOrHide(els.prijs, prijs);

                setLinkOrHide(els.brochure, brochure);
                setLinkOrHide(els.paspoort, paspoort);
                setLinkOrHide(els.info, info);

                // Carousel
                const pics = fotos.length ? fotos : (imgUrl ? [imgUrl] : []);
                if (!pics.length) {
                    clearCarousel();
                } else if (pics.length === 1) {
                    renderSingleImage(pics[0], naam || "Kavel");
                } else {
                    renderCarousel(pics, naam || "Kavel");
                }

                // Nieuw: extra kenmerken
                const kenmerken = [
                    ["bouwtype", "details-bouwtype"],
                    ["typewoning", "details-typewoning"],
                    ["bouwnummer", "details-bouwnummer"],
                    ["woonoppervlakte", "details-woonopp"],
                    ["perceeloppervlakte", "details-perceelopp"],
                    ["buitenruimte", "details-buitenruimte"],
                    ["verdieping", "details-verdieping"],
                    ["aantal-kamers", "details-kamers"],
                    ["ligging", "details-ligging"]
                ];

                kenmerken.forEach(([attr, id]) => {
                    const el = document.getElementById(id);
                    if (!el) return;
                    const val = path.getAttribute(`data-${attr}`) || "";
                    if (val && val.trim() !== "") {
                        el.textContent = val;
                        el.parentElement.style.display = "";
                    } else {
                        el.textContent = "";
                        el.parentElement.style.display = "none";
                    }
                });
            }


            function lockBodyScroll() {

                document.documentElement.classList.add("modal-open");
                document.body.classList.add("modal-open");
            }
            function unlockBodyScroll() {

                document.documentElement.classList.remove("modal-open");
                document.body.classList.remove("modal-open");
            }
            function openPanel(){
                if (isOpen) return; isOpen = true;
                previouslyFocusedEl = document.activeElement;
                panel.style.display = "block"; panel.classList.add("is-open");
                if (overlay) overlay.style.display = "block";
                lockBodyScroll(); updateDraggableClass(); activateFocusTrap();
            }
            function closePanel(){
                if (!isOpen) return; isOpen = false;
                panel.classList.remove("is-open");
                if (overlay) overlay.style.display = "none";
                pinnedId = null; pinnedNumericId = null;
                panel.style.display = "none";
                deactivateFocusTrap(); unlockBodyScroll(); updateDraggableClass(); clearCarousel();
                const backTarget = previouslyFocusedEl || null;
                if (backTarget && typeof backTarget.focus === "function") backTarget.focus();
                previouslyFocusedEl = null;
            }

            function updateLegendCounts() {
                const areas = svg.querySelectorAll(".hover-area");
                const counts = { available: 0, option: 0, sold: 0, future: 0 };
                areas.forEach(el => {
                    if (el.classList.contains("status-available")) counts.available++;
                    else if (el.classList.contains("status-option")) counts.option++;
                    else if (el.classList.contains("status-sold")) counts.sold++;
                    else counts.future++;
                });
                const total = counts.available + counts.option + counts.sold + counts.future;
                const set = (key, val) => {
                    const badge = legend.querySelector(`[data-count="${key}"]`);
                    if (badge) badge.textContent = String(val);
                };
                set("available", counts.available);
                set("option", counts.option);
                set("sold", counts.sold);
                set("future", counts.future);
                set("all", total);

                updateLegendAria(counts, activeFilter);
            }
            function applyFilter() {
                const areas = svg.querySelectorAll(".hover-area");
                areas.forEach(el => {
                    const match = !activeFilter ? true : el.classList.contains("status-" + activeFilter);
                    el.classList.toggle("is-dimmed", !!activeFilter && !match);
                });
                const legendBtns = Array.from(legend.querySelectorAll("[data-filter]"));
                legendBtns.forEach(btn => {
                    const f = btn.dataset.filter;
                    if (!activeFilter) {
                        btn.classList.remove("muted");
                        btn.classList.toggle("active", f === "all");
                        btn.setAttribute("aria-pressed", f === "all" ? "true" : "false");
                    } else {
                        const isActive = f === activeFilter;
                        btn.classList.toggle("active", isActive);
                        btn.classList.toggle("muted", f !== activeFilter && f !== "all");
                        btn.setAttribute("aria-pressed", isActive ? "true" : "false");
                        if (f === "all") { btn.classList.remove("active"); btn.classList.add("muted"); btn.setAttribute("aria-pressed", "false"); }
                    }
                });
                if (pinnedId) {
                    const openEl = svg.querySelector('.hover-area[data-id="' + pinnedId + '"]');
                    if (openEl && openEl.classList.contains("is-dimmed")) closePanel();
                }
            }

            function renderView(viewId, keepTransform) {
                const v = views.find(x => x.id === viewId) || views[0];
                if (!v) return;

                if (currentView) viewState[currentView] = { scale, panX, panY };
                currentView = v.id;

                bgImg.src = v.background;

                svg.setAttribute("viewBox", v.viewBox);
                svg.setAttribute("preserveAspectRatio", "xMidYMid meet");

                svg.innerHTML = v.tpl.innerHTML;

                updateLegendCounts();
                applyFilter();
                applyA11yToAreas();

                const st = keepTransform ? { scale, panX, panY } : viewState[currentView] || { scale: 1, panX: 0, panY: 0 };
                scale = st.scale; panX = st.panX; panY = st.panY;
                constrainPan(); applyTransform(); updateDraggableClass();

                wrapper.classList.remove("hide-overlays");
                const icon = document.querySelector("#toggle-overlay i");
                if (icon) icon.className = "fa fa-eye";
            }

            // Legend filter
            legend.addEventListener("click", (e) => {
                const btn = e.target.closest("[data-filter]"); if (!btn) return;
                const f = btn.dataset.filter;
                if (f === "all") activeFilter = null;
                else if (activeFilter === f) activeFilter = null;
                else activeFilter = f;
                applyFilter();
                wrapper.classList.remove("hide-overlays");
                const icon = document.querySelector("#toggle-overlay i");
                if (icon) icon.className = "fa fa-eye";
            });

            // Oog toggle
            document.getElementById("toggle-overlay").addEventListener("click", () => {
                wrapper.classList.toggle("hide-overlays");
                const icon = document.querySelector("#toggle-overlay i");
                if (wrapper.classList.contains("hide-overlays")) icon.className = "fa fa-eye-slash"; else icon.className = "fa fa-eye";
            });

            // Zoom
            function zoomAt(clientX, clientY, factor) {
                if (isOpen) return;
                hideTooltip();
                const rect = wrapper.getBoundingClientRect();
                const px = (clientX - rect.left - panX) / scale;
                const py = (clientY - rect.top - panY) / scale;
                const next = Math.max(MIN_SCALE, Math.min(MAX_SCALE, scale * factor));
                if (next === scale) return;
                scale = next;
                panX = clientX - rect.left - px * scale;
                panY = clientY - rect.top - py * scale;
                constrainPan(); applyTransform(); updateDraggableClass();
            }
            const animateReset = () => {
                if (isOpen) return;
                scale = 1; panX = 0; panY = 0;
                applyTransform(); updateDraggableClass(); hideTooltip();
            };

            zoomControls.addEventListener("click", (e) => {
                if (isOpen) return;
                const btn = e.target.closest("[data-zoom]"); if (!btn) return;
                const type = btn.getAttribute("data-zoom");
                const rect = wrapper.getBoundingClientRect();
                const cx = rect.left + rect.width / 2, cy = rect.top + rect.height / 2;

                if (type === "in") return zoomAt(cx, cy, 1.2);
                if (type === "out") return zoomAt(cx, cy, 1 / 1.2);
                if (type === "reset") {
                    animateReset();
                    activeFilter = null;
                    applyFilter();
                    wrapper.classList.remove("hide-overlays");
                    const icon = document.querySelector("#toggle-overlay i");
                    if (icon) icon.className = "fa fa-eye";
                    return;
                }
            });

            // Wheel & dblclick zoom
            wrapper.addEventListener("wheel", (e) => {
                if (isOpen) return;
                if (isUI(e.target)) return;
                hideTooltip(); e.preventDefault(); e.stopPropagation();
                const factor = e.deltaY < 0 ? 1.15 : 1 / 1.15;
                zoomAt(e.clientX, e.clientY, factor);
            }, { passive: false });

            wrapper.addEventListener("dblclick", (e) => {
                if (isOpen) return;
                if (isUI(e.target)) return;
                hideTooltip(); e.preventDefault(); e.stopPropagation();
                zoomAt(e.clientX, e.clientY, e.shiftKey ? 1 / 1.5 : 1.5);
            });

            // Pannen en pinch
            const LEFT = 0;
            const activePointersMap = activePointers;
            wrapper.addEventListener("pointerdown", (e) => {
                if (isOpen) return;
                if (isUI(e.target)) return;
                if (overlay && e.target === overlay) return;
                if (panel.contains(e.target)) return;

                hideTooltip();
                let lastX = e.clientX, lastY = e.clientY;
                let moved = 0;

                activePointersMap.set(e.pointerId, { x: e.clientX, y: e.clientY });

                if (activePointersMap.size === 2) {
                    const pts = Array.from(activePointersMap.values());
                    const dx = pts[0].x - pts[1].x, dy = pts[0].y - pts[1].y;
                    pinch.startDist = Math.hypot(dx, dy) || 1;
                    pinch.startScale = scale;
                    pinch.lastCX = (pts[0].x + pts[1].x) / 2;
                    pinch.lastCY = (pts[0].y + pts[1].y) / 2;
                    isPinching = true;
                    try { wrapper.setPointerCapture(e.pointerId); } catch (_) {}
                    const onMove = (ev) => {
                        activePointersMap.set(ev.pointerId, { x: ev.clientX, y: ev.clientY });
                        if (isPinching && activePointersMap.size >= 2) {
                            const pts2 = Array.from(activePointersMap.values());
                            const dx2 = pts2[0].x - pts2[1].x, dy2 = pts2[0].y - pts2[1].y;
                            const dist = Math.hypot(dx2, dy2) || 1;
                            const cx = (pts2[0].x + pts2[1].x) / 2, cy = (pts2[0].y + pts2[1].y) / 2;
                            const desired = Math.max(MIN_SCALE, Math.min(MAX_SCALE, pinch.startScale * dist / pinch.startDist));
                            const factor = desired / scale; if (factor !== 1) zoomAt(cx, cy, factor);
                            panX += (cx - pinch.lastCX); panY += (cy - pinch.lastCY);
                            pinch.lastCX = cx; pinch.lastCY = cy;
                            constrainPan(); applyTransform(); updateDraggableClass(); ev.preventDefault(); ev.stopPropagation();
                        }
                    };
                    const onUp = (ev) => {
                        activePointersMap.delete(ev.pointerId);
                        try { if (wrapper.hasPointerCapture && wrapper.hasPointerCapture(ev.pointerId)) wrapper.releasePointerCapture(ev.pointerId); } catch(_){}
                        if (isPinching && activePointersMap.size < 2) isPinching = false;
                        wrapper.removeEventListener("pointermove", onMove);
                        wrapper.removeEventListener("pointerup", onUp);
                        wrapper.classList.remove("panning"); svg.style.pointerEvents = "";
                    };
                    wrapper.addEventListener("pointermove", onMove, { passive: false });
                    wrapper.addEventListener("pointerup", onUp, { once: true });
                    return;
                }

                const onHoverArea = !!e.target.closest(".hover-area");
                if (e.button === LEFT && scale > 1) {
                    wrapper.classList.add("panning"); svg.style.pointerEvents = "none";
                    const onMove = (ev) => {
                        const dx = ev.clientX - lastX; const dy = ev.clientY - lastY;
                        lastX = ev.clientX; lastY = ev.clientY; moved += Math.abs(dx) + Math.abs(dy);
                        if (moved < 1) return;
                        panX += dx; panY += dy; constrainPan(); applyTransform(); hideTooltip();
                        ev.preventDefault(); ev.stopPropagation();
                    };
                    const onUp = (ev) => {
                        wrapper.classList.remove("panning"); svg.style.pointerEvents = "";
                        wrapper.removeEventListener("pointermove", onMove);
                    };
                    wrapper.addEventListener("pointermove", onMove, { passive: false });
                    wrapper.addEventListener("pointerup", onUp, { once: true });
                    e.preventDefault(); e.stopPropagation();
                    return;
                }
                const canPan = (e.button === 1) || (!onHoverArea) || (e.shiftKey);
                if (!canPan) return;
                wrapper.classList.add("panning"); svg.style.pointerEvents = "none";
                const onMove = (ev) => {
                    const dx = ev.clientX - lastX; const dy = ev.clientY - lastY;
                    lastX = ev.clientX; lastY = ev.clientY; moved += Math.abs(dx) + Math.abs(dy);
                    if (moved < 1) return;
                    panX += dx; panY += dy; constrainPan(); applyTransform(); hideTooltip();
                    ev.preventDefault(); ev.stopPropagation();
                };
                const onUp = (ev) => {
                    wrapper.classList.remove("panning"); svg.style.pointerEvents = "";
                    wrapper.removeEventListener("pointermove", onMove);
                };
                wrapper.addEventListener("pointermove", onMove, { passive: false });
                wrapper.addEventListener("pointerup", onUp, { once: true });
                e.preventDefault(); e.stopPropagation();
            });

            // Tooltip en open panel
            svg.addEventListener("mousemove", (e) => {
                if (pinnedId) return;
                const t = e.target.closest(".hover-area");
                if (!t) { hideTooltip(); return; }
                tooltip.classList.remove("is-mini");
                tooltip.innerHTML = buildTooltipHTMLFromPath(t, false);
                const rect = wrapper.getBoundingClientRect();
                const x = e.clientX, y = e.clientY;
                const tw = tooltip.offsetWidth, th = tooltip.offsetHeight;
                tooltip.style.display = "block";
                tooltip.style.left = Math.max(8, Math.min(x - rect.left + 14, rect.width - tw - 8)) + "px";
                tooltip.style.top  = Math.max(8, Math.min(y - rect.top + 14, rect.height - th - 8)) + "px";
            });
            svg.addEventListener("mouseleave", () => { if (!pinnedId) hideTooltip(); });

            let lastTapId = null, lastTapTime = 0;
            svg.addEventListener("touchstart", (e) => {
                if (e.touches && e.touches.length > 1) return;
                const t = e.target.closest(".hover-area"); if (!t) return;
                const now = Date.now();
                const id = t.getAttribute("data-id");
                const rect = wrapper.getBoundingClientRect();
                const tx = e.touches?.[0]?.clientX || rect.left + rect.width / 2;
                const ty = e.touches?.[0]?.clientY || rect.top + rect.height / 2;
                if (Date.now() < suppressClickUntil) return;
                if (lastTapId === id && (now - lastTapTime) < 800) {
                    pinnedId = id; pinnedNumericId = Number(id);
                    hideTooltip(); fillPanelFromPath(t); openPanel(); lastTapId = null; return;
                }
                lastTapId = id; lastTapTime = now;
                tooltip.classList.add("is-mini");
                tooltip.innerHTML = buildTooltipHTMLFromPath(t, true);
                moveTooltip(tx, ty);
                setTimeout(() => { if (!isOpen) hideTooltip(); }, 1200);
            }, { passive: true });

            svg.addEventListener("click", (e) => {
                const t = e.target.closest(".hover-area"); if (!t) return;
                pinnedId = t.getAttribute("data-id"); pinnedNumericId = Number(pinnedId);
                hideTooltip(); fillPanelFromPath(t); openPanel(); // <— GEEN auto-zoom/safe-zone (VP5 verwijderd)
            });

            panel.querySelector("[data-action='close']")?.addEventListener("click", closePanel);
            overlay?.addEventListener("click", closePanel);
            document.addEventListener("keydown", (e) => { if (e.key === "Escape") closePanel(); });
            svg.addEventListener("keydown", (e) => {
                if (e.key !== "Enter" && e.key !== " ") return;
                const t = e.target.closest(".hover-area"); if (!t) return;
                e.preventDefault();
                pinnedId = t.getAttribute("data-id"); pinnedNumericId = Number(pinnedId);
                fillPanelFromPath(t); openPanel(); // <— GEEN auto-zoom/safe-zone (VP5 verwijderd)
            });

            // View select en hash
            function parseHash() {
                const h = new URLSearchParams((location.hash || "").replace(/^#/, ""));
                return { view: h.get("view"), bnr: h.get("bnr") };
            }
            function updateHash(extra) {
                const h = new URLSearchParams();
                h.set("view", currentView || views[0]?.id || "");
                if (pinnedId) h.set("bnr", String(pinnedId));
                if (extra && extra.clearBnr) h.delete("bnr");
                location.hash = h.toString();
            }
            viewSelect?.addEventListener("change", () => {
                closePanel();
                renderView(viewSelect.value, false);
                updateHash();
            });

            // Init
            const initial = parseHash();
            const startView = views.find(v => v.id === initial.view)?.id || views[0]?.id;
            if (!startView) return;
            if (viewSelect) viewSelect.value = startView;
            renderView(startView, false);

            if (initial.bnr) {
                const path = svg.querySelector(`.hover-area[data-id="${initial.bnr}"]`);
                if (path) { pinnedId = String(initial.bnr); pinnedNumericId = Number(initial.bnr); fillPanelFromPath(path); openPanel(); }
                else { updateHash({ clearBnr: true }); }
            }

            // Hoogte dynamisch
            const controls = document.getElementById("controls");
            function sizeMapToViewport() {
                const vh = (window.visualViewport ? window.visualViewport.height : window.innerHeight);
                const controlsH = controls ? controls.getBoundingClientRect().height : 0;
                const gap = 16;
                let desired = Math.max(360, vh - controlsH - gap);
                const cap = Math.max(320, Math.floor(vh * 0.60));
                if (desired > cap) desired = cap;
                wrapper.style.height = desired + "px";
            }
            sizeMapToViewport();
            let resizeScheduled = false;
            const onResize = () => {
                if (resizeScheduled) return;
                resizeScheduled = true;
                requestAnimationFrame(() => {
                    resizeScheduled = false;
                    sizeMapToViewport(); constrainPan(); applyTransform(); updateDraggableClass();
                });
            };
            window.addEventListener("resize", onResize);
            window.visualViewport?.addEventListener("resize", onResize);

            // Fullscreen HUD
            const legendHome = { parent: legend.parentNode, next: legend.nextSibling };
            const viewHome   = { parent: viewSelectWrap.parentNode, next: viewSelectWrap.nextSibling };
            function placeBack(node, home){
                if (!home?.parent) return;
                if (home.next) home.parent.insertBefore(node, home.next);
                else home.parent.appendChild(node);
            }
            function isFullscreen() {
                return document.fullscreenElement === wrapper || document.webkitFullscreenElement === wrapper;
            }
            async function enterFullscreen() {
                if (wrapper.requestFullscreen) await wrapper.requestFullscreen();
                else if (wrapper.webkitRequestFullscreen) await wrapper.webkitRequestFullscreen();
            }
            async function exitFullscreen() {
                if (document.exitFullscreen) await document.exitFullscreen();
                else if (document.webkitExitFullscreen) await document.webkitExitFullscreen();
            }
            fsBtn?.addEventListener("click", async () => {
                try { if (!isFullscreen()) await enterFullscreen(); else await exitFullscreen(); } catch(e){}
            });

            let fsUi = null;
            ["fullscreenchange","webkitfullscreenchange"].forEach(evt => {
                document.addEventListener(evt, () => {
                    const icon = fsBtn?.querySelector("i");
                    const entering = isFullscreen();

                    if (entering) {
                        wrapper.classList.add("fs-on");
                        if (!fsUi) { fsUi = document.createElement("div"); fsUi.className = "fs-ui"; fsUi.style.pointerEvents = "auto"; wrapper.appendChild(fsUi); }
                        fsUi.appendChild(legend);
                        fsUi.appendChild(viewSelectWrap);
                        legend.style.pointerEvents = "auto";
                        viewSelectWrap.style.pointerEvents = "auto";
                        if (icon) icon.className = "fa fa-compress";
                    } else {
                        wrapper.classList.remove("fs-on");
                        if (fsUi && legend.parentNode === fsUi) placeBack(legend, legendHome);
                        if (fsUi && viewSelectWrap.parentNode === fsUi) placeBack(viewSelectWrap, viewHome);
                        fsUi?.remove(); fsUi = null;
                        sizeMapToViewport();
                        if (icon) icon.className = "fa fa-expand";
                    }
                    constrainPan(); applyTransform(); updateDraggableClass();
                });
            });
        });
    })(window);





